<button class="btn-zoom minus" data-testingId="zoom-minus-btn" (click)="zoomOut()">-</button>
<div class="input-wrapper">
  <input data-testingId="zoomInput" type="number" [(ngModel)]="source.ZoomLevel" (input)="onZoomInputChanged($event, source)"
    matTooltip="Zoom Level" name="ZoomLevel"/>
</div>
<button class="btn-zoom plus" data-testingId="zoom-plus-btn" (click)="zoomIn()">+</button>
